import { VIDEOS_PANEL_STOCK_SKELETON_HEIGTS } from "../constants";
import { StockVideoSkeleton } from "./stock-video-skeleton";

interface IProps {
  noAnim?: boolean;
}

export const StockSkeleton = ({ noAnim }: IProps) => {
  return (
    <div className="tw-grid tw-size-full tw-grid-cols-3 tw-gap-2 tw-overflow-hidden tw-px-4">
      <ColSkeleton
        heights={VIDEOS_PANEL_STOCK_SKELETON_HEIGTS[0]}
        noAnim={noAnim}
      />
      <ColSkeleton
        heights={VIDEOS_PANEL_STOCK_SKELETON_HEIGTS[1]}
        noAnim={noAnim}
      />
      <ColSkeleton
        heights={VIDEOS_PANEL_STOCK_SKELETON_HEIGTS[2]}
        noAnim={noAnim}
      />
    </div>
  );
};

const ColSkeleton = ({ heights, noAnim }: { heights: number[] } & IProps) => {
  return (
    <ul className="tw-mt-4 tw-grid tw-list-none tw-content-start tw-gap-2">
      {Array.from({ length: 12 }, (_, idx) => (
        <li
          key={idx}
          style={{
            height: heights[idx % heights.length],
          }}
        >
          <StockVideoSkeleton noAnim={noAnim} />
        </li>
      ))}
    </ul>
  );
};
